/*
 * @Author: mark
 * @Date: 2022-02-24 16:22:40
 * @LastEditors: zhangyigong 947028660@qq.com
 * @LastEditTime: 2022-05-11 12:10:27
 */
import request from "./request";

import { AxiosPromise } from "axios";

//获取头部cms信息列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selCms = (params: any): AxiosPromise<any> =>
  request({
    url: "v1/itemDetails/listByItemCodes",
    method: "GET",
    params
  });

//获取头部列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selCmsMenu = (params: any): AxiosPromise<any> =>
  request({
    url: "v1/menu",
    method: "GET",
    params
  });

//获取文章列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selArticleList = (params: any): AxiosPromise<any> =>
  request({
    url: "v1/article",
    method: "GET",
    params
  });

//获取首页所有信息
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selHomeDetail = (): AxiosPromise<any> =>
  request({
    url: "v1/menu/articleList",
    method: "GET"
  });

//根据id获取新闻详情
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const selNewsDetailById = (params: any): AxiosPromise<any> =>
  request({
    url: "v1/article/",
    method: "GET",
    params
  });
